import { NgModule } from '@angular/core';
import { SharedCommonModule, SharedComponentsModule } from '@spaq/shared';
import { PopupConfirmDirective } from '@spaq/utils';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupComponent } from './components';

@NgModule({
	imports: [DialogsModule, SharedComponentsModule, SharedCommonModule],
	declarations: [PopupComponent, PopupConfirmDirective],
	exports: [PopupComponent, DialogsModule, PopupConfirmDirective],
	entryComponents: [PopupComponent]
})
export class PopupModule {}
